import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "card-container" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "payment-status-container" }, null, -1)

import { Member, Shop } from '@/models';
import { Auth, DataStore } from 'aws-amplify';
import { inject, onMounted, reactive, ref, toRefs, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import dayjs from 'dayjs';

interface Props {
  member: Member;
  shop: Shop;
}
type CardInfo = {
  card: any | null
}


export default /*#__PURE__*/_defineComponent({
  props: {
    member: null,
    shop: null
  },
  emits: ['stopLoading','startLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
  shop: Shop;
}



const { member, shop } = toRefs(props);



const route = useRoute();
const router = useRouter();

const api: any = inject('api');

const cardInfo : CardInfo = {card: null}
const cardList = ref([]);
const token = ref();

const submit = async() => {
  emit('startLoading');
  try {
    const tokenResult = await cardInfo.card!.tokenize();
    if (tokenResult.status === 'OK') {
      token.value = tokenResult.token;
    }
    else {
      emit('stopLoading');
      console.error(`Tokenization failed with status: ${tokenResult.status}`);
      return;
    }

    var customerId = null;

    const keys = await api.generateEncryptedKeys(`${shop.value.squareAppId}$${shop.value.squareLocationId}$${shop.value.squareAccessToken}`);

    if (!member.value.squareCustomerId) {
      const customer = await api.registCardCustomer({
        token: token.value,
        email: member.value.email,
        familyName: member.value.cardFamilyName,
        givenName: member.value.cardGivenName,
        country: member.value.cardCountry,
        postalCode: member.value.postCode,
        pref: member.value.cardPref,
        address1: member.value.cardAddress1,
        address2: member.value.cardAddress2,
        address3: member.value.cardAddress3,
        phoneNumber: member.value.tel,
        memberId: member.value.id,
        encryptedKeys: keys,
      });

      await DataStore.save(
        Member.copyOf(member.value , updated => {
          updated.squareCustomerId = customer.id;
        })
      );

      customerId = customer.id;
    }
    else {
      customerId = member.value.squareCustomerId;
    }

    const card = await api.registCard({
      uniqueKey: member.value.id.slice(16) + '_' + dayjs().format('YYYYMMDDHHmmss'),
      token: token.value,
      customerId: customerId,
      email: member.value.email,
      familyName: member.value.cardFamilyName,
      givenName: member.value.cardGivenName,
      country: member.value.cardCountry,
      pref: member.value.cardPref,
      address1: member.value.cardAddress1,
      address2: member.value.cardAddress2,
      address3: member.value.cardAddress3,
      phoneNumber: member.value.tel,
      memberId: member.value.id,
      encryptedKeys: keys,
    });

    console.log(card);

    setTimeout(() => {
      emit('stopLoading');
      router.push('payment');
    }, 5000);
  }
  catch(e) {
    console.log(e);
  }
}

watch(member, async() => {
  try {

    if (member.value.squareCustomerId) {
      const keys = await api.generateEncryptedKeys(`${shop.value.squareAppId}$${shop.value.squareLocationId}$${shop.value.squareAccessToken}`);
      cardList.value = await api.getCards(member.value.squareCustomerId, keys);
    }

    let scriptEl = document.createElement('script')
    if (process.env.ENV == 'prod') {
      scriptEl.setAttribute('src', 'https://web.squarecdn.com/v1/square.js');
    }
    else {
      scriptEl.setAttribute('src', 'https://sandbox.web.squarecdn.com/v1/square.js');
    }
    document.head.appendChild(scriptEl);

    setTimeout(async() => {
      try {
        const payments = window.Square.payments(shop.value.squareAppId, shop.value.squareLocationId);
        cardInfo.card = await payments.card();
        const cardOptions = {
          "postalCode": member.value.postCode,
          "style": {
            "input": {
              "fontSize": "18px",
            },
            // You can use media queries with valid selectors:
            "@media screen and (max-width: 600px)": {
              "input": {
                  "fontSize": "18px",
              }
            }
          }
        }

        await cardInfo.card.attach('#card-container');
        await cardInfo.card.configure(cardOptions);
      } catch (e) {
        console.error('Initializing Card failed', e);
      }
      emit('stopLoading');
    }, 2000);
  }
  catch(e) {
    console.log(e);
  }
})

onMounted(() => {
  addEventListener("popstate", () => {
    router.push("/mypage")
  })
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("button", {
      type: "button",
      class: "btn-width",
      onClick: submit
    }, "追加")
  ], 64))
}
}

})